import { IonContent } from '@ionic/react';
import classNames from 'classnames';
import React from 'react';
import { useFormContext } from 'react-hook-form';

import { UiTypography } from '@/components/ui/Typography';
import { useAccount } from '@/hooks/useAccount';
import { amplitudeModule } from '@/modules/amplitude';
import { webCampaign } from '@/modules/webCampaign';
import { LogoWithAppName } from '@/pages/Onboarding/components/LogoWithAppName';
import { OnboardingPage } from '@/pages/Onboarding/components/Page';
import { OnboardingTitle } from '@/pages/Onboarding/components/Title';
import { useOnboarding } from '@/pages/Onboarding/context';
import { OnbOptionType } from '@/pages/Onboarding/types';
import { nextStepTimeout } from '@/pages/Onboarding/utils/nextStepTimeout';
import { userService } from '@/services/user';
import { canLogEvents } from '@/utils/canLogEvents';

import { LayoutDataType } from '../../types';

import { OPTIONS } from './constants';
import './Gender.scss';

export const OnboardingReplikaGender: React.FC = () => {
  const { user } = useAccount();

  React.useEffect(() => {
    if (user && canLogEvents()) {
      amplitudeModule.logEvent('onboarding_screen', {
        seen: 'Gender',
      });
    }
  }, [user]);

  const { wizard } = useOnboarding();

  const { watch, setValue } = useFormContext<LayoutDataType>();
  const gender = watch('gender');

  const handleSelect = (option: OnbOptionType<LayoutDataType['gender']>) => {
    setValue('gender', option.id);
    userService.createOrUpdate({
      onboarding_data: {
        gender: option.title,
      },
    });
    nextStepTimeout(wizard.nextStep);
  };

  return (
    <OnboardingPage className="onboarding-gender">
      <LogoWithAppName />

      <OnboardingTitle color="black" className="onboarding-gender__title">
        Welcome to the most exciting AI universe for your self-expression
      </OnboardingTitle>

      <IonContent>
        <div className={classNames('image-container', webCampaign.aiType)}>
          <img
            alt="AI"
            src="https://d3hhlnlnie19wm.cloudfront.net/web-onb/assets/characters/girl/greet.png"
          />
        </div>
        <div className="onboarding-gender-options">
          {OPTIONS.map((option) => (
            <div
              key={option.id}
              onClick={() => handleSelect(option)}
              className={classNames('onboarding-gender-options-item', {
                selected: option.id === gender,
              })}
            >
              <UiTypography
                variant="body-medium"
                color="neutral-white"
                align="center"
              >
                I am a
              </UiTypography>
              <UiTypography variant="body-large" color="white" align="center">
                {option.title}
              </UiTypography>
            </div>
          ))}
        </div>
      </IonContent>
    </OnboardingPage>
  );
};
